import React from "react";
import { FilterField, FilterGroup, FilterPanel, ListSearchForm, SearchToolbar } from "../../common/DataList";
import { STATUTS_ENVOI } from "./useRDOInviteList";

// Critères de la liste des invitations RDO : mêmes clés qu'avant
// (rdo/relances/chercher) ; les deux dates d'envoi forment une période.
export const definitionsInvitationsRDO = (orgs = []) => {
  const orientations = [...orgs, { id: "none", slugName: "none", name: "Sans orientation" }];
  return [
    {
      name: "statut",
      group: "envoi",
      label: "Statut",
      type: "select",
      firstOptionLabel: "Tous",
      options: [
        { id: STATUTS_ENVOI.A_TRAITER, name: "À traiter" },
        { id: STATUTS_ENVOI.EN_COURS, name: "En cours" },
        { id: STATUTS_ENVOI.ENVOYE, name: "Envoyé" },
        { id: STATUTS_ENVOI.ERREUR, name: "Erreur" },
      ],
    },
    { name: "numeroLot", group: "envoi", label: "Numéro de lot", placeholder: "LOT-2024-1", size: "md" },
    {
      name: "dateEnvoi",
      group: "envoi",
      label: "Date d'envoi",
      type: "dateRange",
      from: "dateEnvoiDebut",
      to: "dateEnvoiFin",
      fromLabel: "Date d'envoi (début)",
      toLabel: "Date d'envoi (fin)",
    },
    {
      name: "orientationAvantRDO",
      group: "orientation",
      label: "Orientation avant RDO",
      type: "select",
      dataIndex: "slugName",
      firstOptionLabel: "Tous",
      options: orientations,
    },
    {
      name: "orientationApresRDO",
      group: "orientation",
      label: "Orientation après RDO",
      type: "select",
      dataIndex: "slugName",
      firstOptionLabel: "Tous",
      options: orientations,
    },
  ];
};

const GROUPES = [
  { id: "envoi", title: "Envoi" },
  { id: "orientation", title: "Orientation" },
];

const RDOInviteListFilters = ({ search, updateSearch, resetFilters, orgs, searchInvitations, isLoading }) => {
  const definitions = definitionsInvitationsRDO(orgs);
  return (
    <ListSearchForm onSubmit={() => searchInvitations()} aria-label="Recherche d'invitations RDO" className="mb-3">
      <SearchToolbar
        id="terms"
        name="terms"
        value={search.filters.terms}
        onChange={updateSearch}
        placeholder="Nom, prénom, email, NIR, matricule CAF…"
        isLoading={isLoading}
      />
      <FilterPanel
        id="rdo-invite-filters"
        title="Filtres"
        showApply={false}
        onReset={resetFilters}
        resetLabel="Réinitialiser"
      >
        {GROUPES.map((groupe) => (
          <FilterGroup key={groupe.id} title={groupe.title}>
            {definitions
              .filter((d) => d.group === groupe.id)
              .map((definition) => (
                <FilterField
                  key={definition.name}
                  definition={definition}
                  value={search.filters[definition.name]}
                  values={search.filters}
                  onChange={updateSearch}
                  onSet={(name, value) => updateSearch({ target: { name, value } })}
                />
              ))}
          </FilterGroup>
        ))}
      </FilterPanel>
    </ListSearchForm>
  );
};

export default RDOInviteListFilters;
